import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import CusProgressBar from '../components/CusProgressBar';
import {FormTitle, CusFormSectionLabel} from '../validation/Form-Components';
import config from '../appconfig/config.json';
import service from '../services/ApiService';
import { useHistory } from "react-router-dom";
import SubHeader from '../components/SubHeader';
import appDetailsData from '../data/applicantdetailsdata.json';
import countryCodes from '../data/countrycode.json';
import Loading from '../components/Loading';
import helper from '../factory/Helper.js';
import AuthPerson from './AuthPerson';
import titles from '../data/titles.json';
import marStatusArray from '../data/maritalstatus.json';
import occupations from '../data/industrylist.json';
import countriesRisk from '../data/countrieswealth.json';
import countriesDomicile from '../data/domicilecountries.json';
import uploadConfig from '../data/uploaddetailsdata.json';
import storage from '../factory/StorageFactory';
import CusToast from '../components/CusToast';
import ToggleShowDetails from '../components/ToggleShowDetails';
 
let PersWealthSG1='Y',PersWealthSG2='Y';

const ShareholdersDetails = (props) => {
  
    let timer;
    const pureSHPositionCode = '000';
    const detailsType='3', SHSeq1 = '1', SHSeq2 = '2', SHSeq3 = '3';

    const dobRegex = new RegExp(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);

    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 40 };

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [isExpendSH1,setIsExpendSH1] = useState(true);
    const [isExpendSH2,setIsExpendSH2] = useState(true);
 

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);

    const [hasMyInfo, setHasMyInfo] = useState(false);
    const [hasMyInfo2, setHasMyInfo2] = useState(false);
 
 
    const [shareholders, setShareholders]  = useState([]);
    const [response, setResponse]  = useState();
    const [totalAuthPerson,setTotalAuthPerson] = useState();
 
    const [shareholderDtls1, setShareholderDtls1] = useState(null);

    const [shareholderDtls2, setShareholderDtls2] = useState(null);

    const [initFormData, setInitFormData] = useState({
        nameCbo1:"",
        titleCbo1:"",
        marStatusCbo1:"",
        counOfDomicileCbo1:"",
        mno1:"",
        em1:"",

        DescActOcc11:'',
        DescActOcc21:'',
        DescActOcc31:'',
 
        SG1: false,
        BN1: false,
        MY1: false,
        CN1: false,
        ID1: false,
        IN1: false,
        OTH1: false,
        PersWealthOTH1: '',

        nameCbo2:'',
        mno2:"",
        em2:"",
        titleCbo2:"",
        marStatusCbo2:"",
        counOfDomicileCbo2:"",

        DescActOcc12:'',
        DescActOcc22:'',
        DescActOcc32:'',

        SG2: false,
        BN2: false,
        MY2: false,
        CN2: false,
        ID2: false,
        IN2: false,
        OTH2: false,
        PersWealthOTH2: ''      
    })

    useEffect(() => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        window.scrollTo(0,0);
        getStateId();
        initVariable();
        getData();

        return () => clearTimeout(timer);
    }, []);

    const initVariable = () => {
 
        PersWealthSG1='Y'; PersWealthSG2='Y';
    }
    
     //show / hide ApplicantDetails
     const [showDetails, setShowDetails] = useState(false);
     const [showDetails2, setShowDetails2] = useState(false);
     
    const createHolders = (data) => {
        let temp = getAllPureSHoldersDtls(data);
 
        setShareholders(temp);
    }

    const createTotalAuthPerson = (data) => {  //Num of AP
        let count = 0;
        if(!Array.isArray(data.ApplicantDtls)) {
            count = 1;
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].Authorised === 'true') {
                    count = count+1;
                }
            }
          
        }
        setTotalAuthPerson(count);
    }

    const getAllPureSHoldersDtls = (data) => {
        let temp = [];
        if(!Array.isArray(data.Holdersdetails)) {
        
            if(data.Holdersdetails.IDNum !== null && data.Holdersdetails.Name !== null) {
                if(data.Holdersdetails.Designation ===  pureSHPositionCode) {

                    temp.push(data.Holdersdetails);
                }
            }
        }
        else {
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNum !== null && data.Holdersdetails[i].Name !== null){
                    if(data.Holdersdetails[i].Designation === pureSHPositionCode) {
                        temp.push(data.Holdersdetails[i]);
                    }
                }
            }
        }
   
        return temp;
    }

    const getNonAPShareHolders = (data) => { // Shareholders did not save as AP in Applicant Details(Pure Share Holder)
        let tempSH = [];
        let allHolders = getAllPureSHoldersDtls(data);
        let allAuthPers = getShareholderAuthPerDtls(data);
    
        if(allAuthPers.length !== 0) {
            for(let i in allHolders) {
                 for(let j in allAuthPers) {
 
                    if(allAuthPers[j].IDNum !== allHolders[i].IDNum) {
                        tempSH.push(allHolders[i])
                    }
                 }
            }
        }
        else { // return all holders
            tempSH = allHolders;
        }

   
        return tempSH;
    }
 
    const checkSHDtlsSaved = (data) => {
        let value = false;
        if(!Array.isArray(data.ApplicantDtls)) {
            if(data.ApplicantDtls.Authorised === 'false'){
                value = true;
            }
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].Authorised === 'false'){
                    value = true;
                }
            }
        }
        
        return value;
    }

    const getShareholderAuthPerDtls = (data) => {
        let temp = [];
     
        if(!Array.isArray(data.ApplicantDtls)) {
            const positionCode = helper.getDesignationbyIDNum(data.ApplicantDtls.IDNum,data.Holdersdetails);
         
            if(positionCode === pureSHPositionCode) {
                temp.push(data.ApplicantDtls);
            }
        }
        else { // array
            for(let i in data.ApplicantDtls) {
 
                const positionCode = helper.getDesignationbyIDNum(data.ApplicantDtls[i].IDNum,data.Holdersdetails);
          
                if(positionCode === pureSHPositionCode) {
                    temp.push(data.ApplicantDtls[i]);
                }
            }
        }
        console.log('getShareholderAuthPerDtls',temp);
   
        return temp;
    }
 

    const handleSubmit = (eve) => {
 
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
     
        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
            if(!validateApplicantDtls()) {
                showErrMsg(config.error.MyInfo.MissingDataSubAP);
                return;
            }
            else if(!validateApplicantDtlsDOB()) {
                showErrMsg(config.error.MyInfo.InvalidDOBSubAP);
                return;
            }
            else if(!validatePersWealthCntyFormSubmit(data)){
                //console.log('one of the invalid fields')
                return;
            }

           saveApplicantDetails(formatJsonParams(data));
        }
        
    }

    const validateApplicantDtls = () => {
        const firstSH = totalAuthPerson+1;
        const secondSH = totalAuthPerson+2;
        const thirdSH = totalAuthPerson+3;

        if(getLoginUserOrder() === firstSH.toString() && hasMyInfo) {
            return validateMyInfoMandatoryFields(shareholderDtls1,'Shareholder 1: ');
        }
        else if(getLoginUserOrder() === secondSH.toString() && hasMyInfo2) {
         
            return validateMyInfoMandatoryFields(shareholderDtls2,'Shareholder 2: ');
        }
        else {
            return true;
        }
    }

    const validateApplicantDtlsDOB = () => {
        const firstSH = totalAuthPerson+1;
        const secondSH = totalAuthPerson+2;
        if(getLoginUserOrder() ===   firstSH && hasMyInfo) {
            return validateMyInfoDOBFormat(shareholderDtls1,'Shareholder 1: ');
        }
        else if(getLoginUserOrder() === secondSH && hasMyInfo2) {
         
            return validateMyInfoDOBFormat(shareholderDtls2,'Shareholder 2: ');
        }
        else {
            return true;
        }
    }

    const getObjInArrayforCompType = (iValue, array) => {
        const result = array.find( ({ value }) => value === iValue);
        return result;
    }

    const checkCompType = (data) => {
        const compTypeCode = data.CompDtls.CompTypeCode !== null? data.CompDtls.CompTypeCode:data.RegBizMailAddr.CompTypeCode;
         
        if(getObjInArrayforCompType(compTypeCode,uploadConfig.scenario1CompTypes) !== undefined) {
            storage.setCompType(uploadConfig.SCOType.SCO1);
        }
        else if(getObjInArrayforCompType(compTypeCode,uploadConfig.scenario2CompTypes) !== undefined) {
            storage.setCompType(uploadConfig.SCOType.SCO2);
        }
        else if(getObjInArrayforCompType(compTypeCode,uploadConfig.scenario3CompTypes) !== undefined) {
            storage.setCompType(uploadConfig.SCOType.SCO3);
        }
        else if(getObjInArrayforCompType(compTypeCode,uploadConfig.scenario4CompTypes) !== undefined) {
            storage.setCompType(uploadConfig.SCOType.SCO4);
        }
        else {  
            storage.setCompType(uploadConfig.SCOType.SCO1);
        }
    }
    
    const saveApplicantDetails = (params) => {
       
        if(!validateForm(params.ApplicantDtls)) {
            return;
        }
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data
            if(resData.isSucess) {
                storage.setSHSaved(true);
                goNext();
            }  
            else{
                showErrMsg(resData.errorMessage);
            }         
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg('Error: Save failed.');
        });
  
    }

    const validatePersWealthCntyFormSubmit = (data) => {
 
        let isValid=true;
        const errMsg =appDetailsData.label.ctrySourceWealth+": "+config.error.SelectChk5;
  
        if(getShareholderSeq() === SHSeq1) {
          
            const json = formatApplicantObj1(data);
            if(json.PersWealthSG === 'N') {
                if(!helper.validateNoOfCheckedBox(json.PersWealthCou,1,5)) {
                    showErrMsg(errMsg);
                    isValid=false;
                }
                else { 
                    isValid=true;
                }
            }
        }
        else if(getShareholderSeq() === SHSeq2) {
        
            const json = formatApplicantObj2(data);
            if(json.PersWealthSG === 'N') {
                if(!helper.validateNoOfCheckedBox(json.PersWealthCou,1,5)) {
                    showErrMsg(errMsg);
                    isValid=false;
                }
                else { 
                    isValid=true;
                }
            }
        }
        

        return isValid;
    }

    const validateForm = (authDtlsArray) => {
        let isValid = true;
        const errMsgDesp = 'Please do not leave field blank.\nPlease fill in the text field.'
        for(let i in authDtlsArray) {
            if(authDtlsArray[i].SHSeq === SHSeq1) {
                if(!isValidFormInputFields(authDtlsArray[i], hasMyInfo)){
                    setIsExpendSH1(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
        
            }
            if(authDtlsArray[i].SHSeq === SHSeq2) {
                if(!isValidFormInputFields(authDtlsArray[i], hasMyInfo2)){
                    setIsExpendSH2(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
               
            } 
        
        }

        return isValid;
    }
    

  
    const isValidFormInputFields = (formData, hasMyInfo) => {
       
        let isValid = true;
        if(hasMyInfo) {
            if(formData.Title === undefined || formData.Title === '') {
                isValid = false;
            }
            else if(formData.MarStatus === undefined || formData.MarStatus === '') {
                isValid = false;
            }
            else if(formData.CouOfDom === undefined || formData.CouOfDom === '') {
                isValid = false;
            }
            else if(formData.MobileNo === undefined || formData.MobileNo === '') {
                isValid = false;
            }
            else if(formData.EmailAdd === undefined || formData.EmailAdd === '') {
                isValid = false;
            }
            else if(formData.DescAccOccList.DescActOcc.length === 0) {
                isValid = false;
            }
        }
        else {
            if(formData.MobileNo === undefined || formData.MobileNo === '') {
                isValid = false;
            }
            else if(formData.EmailAdd === undefined || formData.EmailAdd === '') {
                isValid = false;
            }
        }

        if(!isValid) {
            showErrMsg('Please do not leave field blank\nPlease fill in the text field.');
        }
   
        return isValid;
    }
    

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
               history.goBack();
            }
        }
        else {
            if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true'){  
                history.push(config.route.NSBizBankingService);
            }
            else {
                history.push(config.route.NSDelegationDetails2);
            }
        }
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const formatJsonParams = (data) => {
 
        let appDtlsArray = [];
 
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {  //1st AP 
            if(getAuthorisedPersons().length !== 0) appDtlsArray = getAuthorisedPersons();
            if(shareholderDtls1 !== null) appDtlsArray.push(formatApplicantObj1(data));
            if(shareholderDtls2 !== null) appDtlsArray.push(formatApplicantObj2(data));
        }
        else {  //sub AP
            if(getShareholderSeq() === SHSeq1){
                if(shareholderDtls1 !== null) appDtlsArray.push(formatApplicantObj1(data));
            }
            else if(getShareholderSeq() === SHSeq2) {
                if(shareholderDtls2 !== null) appDtlsArray.push(formatApplicantObj2(data));
            }
       
        }

        let params = {
            CurrentUser:currentUser(),
            ApplicantDtls:appDtlsArray
        }
     
        return params;
    }

    const currentUser = () => {
        let params = {};
        params = {
            IDNum: response.ApplicantsDtlsMyInfo.IDNum,
            Seq:getLoginUserSeq(),
            Order:getLoginUserOrder(),
            isAuthPerDtlsEdited: getIsAuthPerDtlsEdited()
        }
        return params;
    }

    const getAuthorisedPersons = () => {
        let appDtlsArray=[];
        if(!Array.isArray(response.ApplicantDtls)){
            appDtlsArray.push(response.ApplicantDtls);
        }
        else {
            for(let i in response.ApplicantDtls) {
                if(response.ApplicantDtls[i].Authorised === 'true') {
                    appDtlsArray.push(response.ApplicantDtls[i]);
                }
            }
        }
        return appDtlsArray;
    }

    const getIsAuthPerDtlsEdited = () => {
        let value = true;

        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                value = false;
            }
        }
        else if(response.ApplicantsDtlsMyInfo.isFirstUser === 'false'){
            value = false;
        }
        else {  
            value = storage.getIsAPEdited() === 'true'? true:false;
        }

        return value;
    }

    const getShareholderSeq = () => {
        if(!Array.isArray(response.ApplicantDtls)){ 
            return response.ApplicantDtls.SHSeq;
        }
        else {
            for(let i in response.ApplicantDtls) {
                if(response.ApplicantDtls[i].IDNum ===  response.ApplicantsDtlsMyInfo.IDNum) {  // get login user's seq number 
                    return response.ApplicantDtls[i].SHSeq;
                }
            }
        }
    }

    const getLoginUserOrder = () => {
        let authSeq = '', isAuthPerson = false;
     
        if(!Array.isArray(response.ApplicantDtls)){ //check obj or array
            if(response.ApplicantDtls.IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                authSeq = response.ApplicantDtls.ApplicantSeq;
                isAuthPerson = true;
            }
            else {  //non login user
                authSeq = '0';
                isAuthPerson = false;
            }
        }
        else { //array
            for(let i in response.ApplicantDtls) {
 
                if(response.ApplicantDtls[i].IDNum ===  response.ApplicantsDtlsMyInfo.IDNum) {  // get login user's seq number 
                    authSeq = response.ApplicantDtls[i].ApplicantSeq;
                    isAuthPerson = true;
                }
            }
        }
        
        if(isAuthPerson){
            return authSeq;
        }
        else {
            return '0';
        }
    }


    const getLoginUserSeq = () => {
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
            return '0';  // first user, default return 0
        }
        else {// not first login person, get current login user seq from ApplicantDtls array
            return getNonFirstUserSeq();
        }
    }

    const getNonFirstUserSeq = () => {
        if(!Array.isArray(response.ApplicantDtls)){ //check obj
            if(response.ApplicantDtls.IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                return response.ApplicantDtls.ApplicantSeq;
            }
        }
        else { //array
            for(let i in response.ApplicantDtls){
                if(response.ApplicantDtls[i].IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                    return response.ApplicantDtls[i].ApplicantSeq;
                }
            }
        }
    }

    const occupationList1 = (data) => {
   
        let occList = [];
     
        if(data.DescActOcc11){
            occList.push(data.DescActOcc11.value);
        }
        if(data.DescActOcc21){
            occList.push(data.DescActOcc21.value);
        }
        if(data.DescActOcc31) {
            occList.push(data.DescActOcc31.value);
        }
      
        return occList;
    }

    const occupationList2 = (data) => {
        let occList = [];
     
        if(data.DescActOcc12){
            occList.push(data.DescActOcc12.value);
        }
        if(data.DescActOcc22){
            occList.push(data.DescActOcc22.value);
        }
        if(data.DescActOcc32) {
            occList.push(data.DescActOcc32.value);
        }

        return occList;
    }

    const occupationList3 = (data) => {
        let occList = [];
     
        if(data.DescActOcc13){
            occList.push(data.DescActOcc13.value);
        }
        if(data.DescActOcc23){
            occList.push(data.DescActOcc23.value);
        }
        if(data.DescActOcc33) {
            occList.push(data.DescActOcc33.value);
        }

        return occList;
    }

 
    const formatApplicantObj1 = (data) => {
        let ApplicantDtls1={};
        if(hasMyInfo) {
       
            PersWealthSG1 = PersWealthSG1 === null? 'Y':PersWealthSG1;
            
            ApplicantDtls1 = {
                Name: shareholderDtls1.myInfo.Name,   
                ApplicantSeq:totalAuthPerson+1,
                IDNum: shareholderDtls1.myInfo.IDNum,  
                Title: data.titleCbo1.value,
                MarStatus: data.marStatusCbo1.value,
                CouOfDom: data.counOfDomicileCbo1.value,
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno1,
                EmailAdd: data.em1,
                PersWealthSG: PersWealthSG1,
                PersWealthCou: {
                    SG: PersWealthSG1 === 'Y'?false: data.SG1,
                    BN: PersWealthSG1 === 'Y'?false: data.BN1,
                    MY: PersWealthSG1 === 'Y'?false: data.MY1,
                    CN: PersWealthSG1 === 'Y'?false: data.CN1,
                    ID: PersWealthSG1 === 'Y'?false: data.ID1,
                    IN: PersWealthSG1 === 'Y'?false: data.IN1,
                    OTH: PersWealthSG1 === 'Y'?false: data.OTH1,
                    PersWealthOTH:PersWealthSG1 === 'Y'? null: data.OTH1? data.PersWealthOTH1.value:null
                },
                DescAccOccList : {
                    DescActOcc:occupationList1(data)
                },
                Authorised:false, 
                SHSeq:SHSeq1 //shareholder seq 
            }
        }
        else {
 
            ApplicantDtls1 = {
                Name: shareholderDtls1.myInfo.Name,   
                ApplicantSeq: totalAuthPerson+1,
                IDNum: shareholderDtls1.myInfo.IDNum,
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno1,
                EmailAdd: data.em1,
                Authorised:false, 
                SHSeq:SHSeq1 //shareholder seq 
            }
        }

        return ApplicantDtls1;
    }

    const formatApplicantObj2 = (data) => {
        let ApplicantDtls2={};
        if(hasMyInfo2) {

            PersWealthSG2 = PersWealthSG2 === null? 'Y':PersWealthSG2;

            ApplicantDtls2 = {
                Name: shareholderDtls2.myInfo.Name,   
                ApplicantSeq: totalAuthPerson+2,
                IDNum: shareholderDtls2.myInfo.IDNum,
                Title: data.titleCbo2.value,
                MarStatus: data.marStatusCbo2.value,
                CouOfDom: data.counOfDomicileCbo2.value,
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno2,
                EmailAdd: data.em2,

                PersWealthSG: PersWealthSG2,
                PersWealthCou: {
                    SG: PersWealthSG2 === 'Y'? false: data.SG2,
                    BN: PersWealthSG2 === 'Y'? false:  data.BN2,
                    MY: PersWealthSG2 === 'Y'? false: data.MY2,
                    CN: PersWealthSG2 === 'Y'? false: data.CN2,
                    ID: PersWealthSG2 === 'Y'? false: data.ID2,
                    IN: PersWealthSG2 === 'Y'? false: data.IN2,
                    OTH: PersWealthSG2 === 'Y'? false: data.OTH2,
                    PersWealthOTH: PersWealthSG2 === 'Y'? null: data.OTH2? data.PersWealthOTH2.value:null
                },
                DescAccOccList : {
                    DescActOcc:occupationList2(data)
                },
                Authorised:false, 
                SHSeq:SHSeq2 //shareholder seq  
            }
        }
        else {
            ApplicantDtls2 = {
                Name: shareholderDtls2.myInfo.Name,   
                ApplicantSeq: totalAuthPerson+2,
                IDNum: shareholderDtls2.myInfo.IDNum,
                MobileNoCode: countryCodes[0].value,
                MobileNo: data.mno2,
                EmailAdd: data.em2,
                Authorised:false, 
                SHSeq:SHSeq2 //shareholder seq  
            }
        }

       
        return ApplicantDtls2;
    }

 
    const isValidSubAPMyInfo = (data) => {
        let isValid = true;
        const appDtlsMyInfo = data.ApplicantsDtlsMyInfo;
 
        if(appDtlsMyInfo.isFirstUser === 'false') {
            let subAP = {
                myInfo:appDtlsMyInfo
            }
            if(!validateMyInfoMandatoryFields(subAP)){
                showErrMsg(config.error.MyInfo.MissingDataSubAP);
                isValid = false;
            }
            else if(!validateMyInfoDOBFormat(subAP)) {
                showErrMsg(config.error.MyInfo.InvalidDOBSubAP);
                isValid = false;
            }
        }

        return isValid;
    }

 

    const validateMyInfoDOBFormat = (appDtls,title) => {
        let isValid = true;
        if(appDtls.myInfo.DOB !== null || appDtls.myInfo.DOB !== "" || appDtls.myInfo.DOB !== undefined){
            if(dobRegex.test(appDtls.myInfo.DOB) === false) {
                //console.log('invalid DOB format')
                isValid = false;
            }
        }
        return isValid;
    }


    const validateMyInfoMandatoryFields = (appDtls,title) => {
        console.log('validateMyInfoMandatoryFields',appDtls.myInfo.Designation)
        let isValid = true;
        
        if(appDtls.myInfo.IDNum === null || appDtls.myInfo.IDNum === "" || appDtls.myInfo.IDNum === undefined) {
            //console.log('invalid IDNum')
            isValid = false;
        }
        else if(appDtls.myInfo.DOB === null || appDtls.myInfo.DOB === "" || appDtls.myInfo.DOB === undefined) {
            //console.log('invalid DOB')
            isValid = false;
        }
        else if(appDtls.myInfo.Gender === null || appDtls.myInfo.Gender === "" || appDtls.myInfo.Gender === undefined) {
            //console.log('invalid Gender')
            isValid = false;
        }
        else if(appDtls.myInfo.Race === null || appDtls.myInfo.Race === "" || appDtls.myInfo.Race === undefined) {
            //console.log('invalid Race')
            isValid = false;
        }
        else if(appDtls.myInfo.Nationality === null || appDtls.myInfo.Nationality === "" || appDtls.myInfo.Nationality === undefined) {
            //console.log('invalid Nationality')
            isValid = false;
        }
        else if(appDtls.myInfo.CnOfBirth === null || appDtls.myInfo.CnOfBirth === "" || appDtls.myInfo.CnOfBirth === undefined) {
            //console.log('invalid CnOfBirth')
            isValid = false;
        }
        else if(appDtls.myInfo.ResStatus === null || appDtls.myInfo.ResStatus === "" || appDtls.myInfo.ResStatus === undefined) {
            //console.log('invalid ResStatus')
            isValid = false;
        }
        else if(appDtls.myInfo.Designation === null || appDtls.myInfo.Designation === "" || appDtls.myInfo.Designation === undefined) {
            //console.log('invalid Designation')
            isValid = false;  
        }
        else if(appDtls.myInfo.ResAddType === config.addTypeLocal) {
            //console.log('addTypeLocal')
            if(appDtls.myInfo.ResPostalCode === null || appDtls.myInfo.ResPostalCode === "" || appDtls.myInfo.ResPostalCode === undefined) {
                //console.log('invalid ResPostalCode')
                isValid = false;
            }
            else if(appDtls.myInfo.ResBlkNo === null || appDtls.myInfo.ResBlkNo === "" || appDtls.myInfo.ResBlkNo === undefined) {
                //console.log('invalid ResBlkNo')
                isValid = false;
            }
            else if(appDtls.myInfo.ResStreet === null || appDtls.myInfo.ResStreet === "" || appDtls.myInfo.ResStreet === undefined) {
                //console.log('invalid ResStreet')
                isValid = false;
            }
        }
        else if(appDtls.myInfo.ResAddType === config.addTypeForeign || appDtls.myInfo.ResAddType === config.addTypeLocalUnformat) {
            //console.log('addTypeForeign')
            if(appDtls.myInfo.ResAddLine1 === null || appDtls.myInfo.ResAddLine1 === "" || appDtls.myInfo.ResAddLine1 === undefined) {
                //console.log('invalid ResAddLine1')
                isValid = false;
            }
            else if(appDtls.myInfo.ResAddLine2 === null || appDtls.myInfo.ResAddLine2 === "" || appDtls.myInfo.ResAddLine2 === undefined) {
                //console.log('invalid ResAddLine2')
                isValid = false;
            }
        }
       
        return isValid;
    }

    const getStateId = () => {
    
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        let stateId = parsed.state;
        if(stateId) {
            storage.setStateId(stateId);
        }
    }
    
    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess) {
                
                if(res.data.model.fields.Data === "Empty") {  //MyInfo user click close, route to Product page.
                    setIsLoading(false);
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }

                if(!isValidSubAPMyInfo(res.data.model.fields.request)){
                    // setIsLoading(false);
                    // return;
                }

                createHolders(res.data.model.fields.request);
                createTotalAuthPerson(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
                checkCompType(res.data.model.fields.request)  //to use for upload details page routing
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
           
            setIsLoading(false);
            showErrMsg('Error: Get data failed.');
        })
    }

   

    const bindFormData = (resData) => {
        const data = resData.ApplicantDtls;  //to check for first time or not
        try{
            setResponse(resData);
            if(data.length !== 0){
                if(checkSHDtlsSaved(resData)) {  //not first time
                
                    bindAppDtlsFormData(resData);
                }
                else { // first time
                    bindFirstTime(resData);
                }
            }
            else {
                showErrMsg('Error: unable to retrieve data');
            }
        }
        catch(ex) {
            //  console.log('bindFormData ',ex);
        }

        setIsLoading(false);
    }

    const bindFirstTime = (resData) => {
        // console.log('bindFirstTime');
        setHasMyInfo(false);
        setHasMyInfo2(false);
        let holders = getNonAPShareHolders(resData);
 
         if(holders.length === 1) { 
            setShareholderDtls1({
                myInfo:holders[0],
                occupList:[],
                allowEdit:true,
                contactDtlEdit:true
            })
            setShareholderDtls2(null);
         
         }
         else if(holders.length === 2) {
            setShareholderDtls1({
                myInfo:holders[0],
                occupList:[],
                allowEdit:true,
                contactDtlEdit:true
            })
            setShareholderDtls2({
                myInfo:holders[1],
                occupList:[],
                allowEdit:true,
                contactDtlEdit:true
            });
         }
    }

    const bindAppDtlsFormData = (data) => {
        let data1 , data2 , data3;
        let occupArray1=[], occupArray2=[], occupArray3=[],holdersDtls = [];
        if(!Array.isArray(data.ApplicantDtls)) {
            data1 = data.ApplicantDtls;
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].Authorised === 'false') {
                    if(data.ApplicantDtls[i].SHSeq === SHSeq1) data1= data.ApplicantDtls[i];
                    if(data.ApplicantDtls[i].SHSeq === SHSeq2) data2= data.ApplicantDtls[i];
                    if(data.ApplicantDtls[i].SHSeq === SHSeq3) data3 = data.ApplicantDtls[i];
                }
            }
        }

        holdersDtls = getAllPureSHoldersDtls(data);
        if(data1){
       
            occupArray1 = setOccListArray(data1,SHSeq1);
           
            PersWealthSG1 = data1.PersWealthSG && data1.PersWealthSG !==null? data1.PersWealthSG:'Y';
            setHasMyInfo1Value(data1,data);
            setShareholderDtls1({
                myInfo: getLoginUserMyInfoData(data1,data),
                occupList:occupArray1,
                allowEdit:checkAllowEdit(data1,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo)
            })
            setIsExpendSH1(expendLoginUser(data1,data.ApplicantsDtlsMyInfo));
        }
   
        if(data2){ 
            occupArray2 = setOccListArray(data2,SHSeq2);
            
            PersWealthSG2 =data2.PersWealthSG && data2.PersWealthSG !==null? data2.PersWealthSG:'Y';
      
            setHasMyInfo2Value(data2,data);
            setShareholderDtls2({
                myInfo:getLoginUserMyInfoData(data2,data),
                occupList:occupArray2,
                allowEdit:checkAllowEdit(data2,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo)
            })
     
     
            setIsExpendSH2(expendLoginUser(data2,data.ApplicantsDtlsMyInfo));
        }

        setInitFormData({
            nameCbo1:data1.IDNum? helper.getObjInArraybyIDNum(data1.IDNum,holdersDtls):'',
            titleCbo1:data1.Title? helper.getObjInArray(data1.Title,titles):'',
            marStatusCbo1:data1.MarStatus? helper.getObjInArray(data1.MarStatus,marStatusArray):'',
            counOfDomicileCbo1:data1.CouOfDom? helper.getObjInArray(data1.CouOfDom,countriesDomicile):'',
            mno1:data1.MobileNo && data1.MobileNo!==null? data1.MobileNo:'',
            em1:data1.EmailAdd && data1.EmailAdd !==null? data1.EmailAdd:'',
       
            DescActOcc11:helper.getObjInArray(occupArray1[0],occupations),
            DescActOcc21:occupArray1[1]? helper.getObjInArray(occupArray1[1],occupations):'',
            DescActOcc31:occupArray1[2]? helper.getObjInArray(occupArray1[2],occupations):'',
 
            SG1: data1.PersWealthCou && data1.PersWealthCou.SG === 'true'?true:false,
            BN1: data1.PersWealthCou && data1.PersWealthCou.BN === 'true'?true:false,
            MY1: data1.PersWealthCou && data1.PersWealthCou.MY === 'true'?true:false,
            CN1: data1.PersWealthCou && data1.PersWealthCou.CN === 'true'?true:false,
            ID1: data1.PersWealthCou && data1.PersWealthCou.ID === 'true'?true:false,
            IN1: data1.PersWealthCou && data1.PersWealthCou.IN === 'true'?true:false,
            OTH1: data1.PersWealthCou && data1.PersWealthCou.OTH === 'true'?true:false,
            PersWealthOTH1: data1.PersWealthCou && data1.PersWealthCou.OTH === 'true'? helper.getObjInArray(data1.PersWealthCou.PersWealthOTH,countriesRisk):'',

            nameCbo2:data2 && data2.IDNum? helper.getObjInArraybyIDNum(data2.IDNum,holdersDtls):'',
            mno2:data2 && data2.MobileNo && data2.MobileNo!==null? data2.MobileNo:'',
            em2:data2 && data2.EmailAdd && data2.EmailAdd !==null? data2.EmailAdd:'',
            titleCbo2:data2 && data2.Title && data2.Title !==null? helper.getObjInArray(data2.Title,titles):'',
            marStatusCbo2:data2 && data2.MarStatus && data2.MarStatus !==null? helper.getObjInArray(data2.MarStatus,marStatusArray):'',
            counOfDomicileCbo2:data2 && data2.CouOfDom && data2.CouOfDom !==null? helper.getObjInArray(data2.CouOfDom,countriesDomicile):'',
            

            DescActOcc12:occupArray2[0]? helper.getObjInArray(occupArray2[0],occupations):'',
            DescActOcc22:occupArray2[1]? helper.getObjInArray(occupArray2[1],occupations):'',
            DescActOcc32:occupArray2[2]? helper.getObjInArray(occupArray2[2],occupations):'',

            SG2: data2 && data2.PersWealthCou && data2.PersWealthCou.SG === 'true'?true:false,
            BN2: data2 && data2.PersWealthCou && data2.PersWealthCou.BN === 'true'?true:false,
            MY2: data2 && data2.PersWealthCou && data2.PersWealthCou.MY === 'true'?true:false,
            CN2: data2 && data2.PersWealthCou && data2.PersWealthCou.CN === 'true'?true:false,
            ID2: data2 && data2.PersWealthCou && data2.PersWealthCou.ID === 'true'?true:false,
            IN2: data2 && data2.PersWealthCou && data2.PersWealthCou.IN === 'true'?true:false,
            OTH2: data2 && data2.PersWealthCou && data2.PersWealthCou.OTH === 'true'?true:false,
            PersWealthOTH2: data2 && data2.PersWealthCou && data2.PersWealthCou.OTH === 'true'? helper.getObjInArray(data2.PersWealthCou.PersWealthOTH,countriesRisk):'',

            nameCbo3:data3 && data3.IDNum? helper.getObjInArraybyIDNum(data3.IDNum,holdersDtls):'',
            mno3:data3 && data3.MobileNo && data3.MobileNo!==null? data3.MobileNo:'',
            em3:data3 && data3.EmailAdd && data3.EmailAdd !==null? data3.EmailAdd:'',
            titleCbo3:data3 && data3.Title? helper.getObjInArray(data3.Title,titles):'',
            marStatusCbo3:data3 && data3.MarStatus? helper.getObjInArray(data3.MarStatus,marStatusArray):'',
            counOfDomicileCbo3:data3 && data3.CouOfDom? helper.getObjInArray(data3.CouOfDom,countriesDomicile):'',
           
            DescActOcc13:occupArray3[0]? helper.getObjInArray(occupArray3[0],occupations):'',
            DescActOcc23:occupArray3[1]? helper.getObjInArray(occupArray3[1],occupations):'',
            DescActOcc33:occupArray3[2]? helper.getObjInArray(occupArray3[2],occupations):'',
 
            SG3: data3 && data3.PersWealthCou && data3.PersWealthCou.SG === 'true'?true:false,
            BN3: data3 && data3.PersWealthCou && data3.PersWealthCou.BN === 'true'?true:false,
            MY3: data3 && data3.PersWealthCou && data3.PersWealthCou.MY === 'true'?true:false,
            CN3: data3 && data3.PersWealthCou && data3.PersWealthCou.CN === 'true'?true:false,
            ID3: data3 && data3.PersWealthCou && data3.PersWealthCou.ID === 'true'?true:false,
            IN3: data3 &&  data3.PersWealthCou && data3.PersWealthCou.IN === 'true'?true:false,
            OTH3: data3 && data3.PersWealthCou && data3.PersWealthCou.OTH === 'true'?true:false,
            PersWealthOTH3:data3 && data3.PersWealthCou && data3.PersWealthCou.OTH === 'true'? helper.getObjInArray(data3.PersWealthCou.PersWealthOTH,countriesRisk):''
        })
     
    } 

    const goToErrorPage = (errType) => {
        props.history.push(config.route.InvalidEntity,{errType:errType});
    }

    const setHasMyInfo1Value = (data,resData) => {
        let value = false;
        if(data.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){
            value = true;
        }
        else {
            if(data.ApplicantSeq === '2' && resData.SubmittedApplicants.Applicant2 === 'true') {
                value = true;
            }
            else {
                value = false;
            }
        }
 
        setHasMyInfo(value);
    }

    const setHasMyInfo2Value = (data,resData) => {
     
        if(data.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){
            setHasMyInfo2(true);
        }
        else {
  
            if(data.ApplicantSeq === '3' && resData.SubmittedApplicants.Applicant3 === 'true') {
                setHasMyInfo2(true);
            }
            else {
                setHasMyInfo2(false);
            }
        }
    } 
    const getLoginUserMyInfoData = (authDtls,resData) => {
        if(authDtls.IDNum === resData.ApplicantsDtlsMyInfo.IDNum){ // get the login's person
            if(authDtls.DescAccOccList === undefined) {  
                return resData.ApplicantsDtlsMyInfo;
            }
            else {
                return authDtls;
            }
        }
        else {
            return authDtls;
        }
    }

    const setOccListArray = (data,seq) => {
 
        let occArray = [];
        if(data.DescAccOccList !== undefined && data.DescAccOccList !== null){
            if(!Array.isArray(data.DescAccOccList.DescActOcc)) {
                occArray.push(data.DescAccOccList.DescActOcc);
            }
            else {
             
                occArray = data.DescAccOccList.DescActOcc;
            }
        }
  
        return occArray;
    }

    
    
    const checkAllowEdit = (authPerson,loginPerson) => {
 
        if(loginPerson.isFirstUser === 'true') {
            return true;
        }
        else if(authPerson.IDNum === loginPerson.IDNum) {
            return true;
        }
        else {
            return false;
        }

        
    }

    const checkContactDtlsEdit = (loginPerson) => {
        if(loginPerson.isFirstUser === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const expendLoginUser = (authPerson,loginPerson) => {
        if(loginPerson.isFirstUser === 'true') {
            return true;
        }

        if(authPerson.IDNum === loginPerson.IDNum) {
            return true;
        }

        return false;
    }
 

    const handleOnToggleClick = (id) => {
   
        if(id === SHSeq1) {
            setShowDetails(!showDetails)
        }
        else if(id === SHSeq2) {
            setShowDetails2(!showDetails2)
        }
    }

    const onAuthPersonRdoChange = (e, id) => {
  
         if(id === 'PersWealthSG1') {
            PersWealthSG1 = e.value;
        }
        else if(id === 'PersWealthSG2') {
            PersWealthSG2 = e.value;
        }
    }
    
    if(isLoading) {
        return(
          <Loading />
        )
    }

    return(
        <div className="container-fluid">
         <SubHeader />
         <FormContainer>
                <Form onSubmitClick={handleSubmit} 
                    initialValues={initFormData}
                    key={JSON.stringify(initFormData)}
                    render={(formRenderProps)=>(
                    <FormElement>
                        <fieldset>
                            <Field component={FormTitle} id={appDetailsData.formContainerTitle.T1SH} 
                                name={appDetailsData.formContainerTitle.T1SH.name} />
                                
                            <div className="row around-xs inputPairSubTitle elementVisible">
                                <div className="col-xs-12  col-sm-12 col-md-12 col-lg-12">
                                    <div id={appDetailsData.formContainerTitle.T1Desp}>{appDetailsData.formContainerTitle.T1SHDesp.name}</div>
                                </div>
                            </div>

                            <div>
                                <Field component={CusFormSectionLabel} 
                                    leftLabelId={'lblSH1'} 
                                    leftLabelName={appDetailsData.label.shareHolder+' '+SHSeq1} 
                                    id={'SH1'} 
                                    name={shareholderDtls1.myInfo.Name} 
                                    hasAuthUser={shareholderDtls1.myInfo.Name? true:false}
                                    doneMyInfo={hasMyInfo}
                                    isExpend={isExpendSH1} 
                                    onClick={() => {
                                        if(isExpendSH1){
                                            setIsExpendSH1(false);
                                        }
                                        else {
                                            setIsExpendSH1(true);
                                        } 
                                    }} />

                                {isExpendSH1 && 
                                    <div>
                                        {hasMyInfo &&
                                        <FieldWrapper>
                                            <div className="row around-xs inputPair elementVisible">
                                                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                                    <div className="box" style={{ marginTop: "5px" }}>{appDetailsData.label.n}</div>
                                                </div>
                                                <ToggleShowDetails id={SHSeq1} toggle={showDetails} onToggleClick={handleOnToggleClick} />
                                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <div className="box">{shareholderDtls1.myInfo.Name}</div>
                                                </div>
                                            </div>
                                        </FieldWrapper>
                                        }

                                        <AuthPerson applicantDetails={shareholderDtls1} showDetails={showDetails} formRenderProps={formRenderProps}
                                            hasMyInfo={hasMyInfo} seq={SHSeq1} holders={shareholders}
                                            isPureSH={true}
                                            onRdoChange={onAuthPersonRdoChange}
                                            showErrMsg={(msg) => {showErrMsg(msg)}} />

                                        
                                    </div>
                                    }
                            </div>
                            
                            {shareholderDtls2 !== null &&
                            <div>
                                <Field component={CusFormSectionLabel} 
                                    leftLabelId={'lblSH2'} 
                                    leftLabelName={appDetailsData.label.shareHolder+' '+SHSeq2} 
                                    id={'SH2'} 
                                    name={shareholderDtls2.myInfo.Name} 
                                    hasAuthUser={shareholderDtls2.myInfo.Name? true:false}
                                    doneMyInfo={hasMyInfo2}
                                    isExpend={isExpendSH2} 
                                    onClick={() => {
                                        if(isExpendSH2){
                                            setIsExpendSH2(false);
                                        }
                                        else {
                                            setIsExpendSH2(true);
                                        } 
                                    }} />

                                {isExpendSH2 && 
                                <div>
                                    {hasMyInfo2 &&
                                    <FieldWrapper>
                                        <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                                <div className="box" style={{ marginTop: "5px" }}>{appDetailsData.label.n}</div>
                                            </div>
                                            <ToggleShowDetails id={SHSeq2} toggle={showDetails2} onToggleClick={handleOnToggleClick} />
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div className="box">{shareholderDtls2.myInfo.Name}</div>
                                            </div>
                                        </div>   
                                    </FieldWrapper>
                                    }

                                    <AuthPerson applicantDetails={shareholderDtls2} showDetails={showDetails2} formRenderProps={formRenderProps}
                                        hasMyInfo={hasMyInfo2} seq={SHSeq2} holders={shareholders}
                                        isPureSH={true}
                                        onRdoChange={onAuthPersonRdoChange}
                                        showErrMsg={(msg) => {showErrMsg(msg)}} />
                                </div>
                                }
                            </div>
                            }
                             
                            <FieldWrapper>
                                <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} /> 
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                                        {response.ApplicantsDtlsMyInfo.isFirstUser === 'true' &&
                                        <button type={"button"} className="btn btn-back" onClick={(e) => { e.preventDefault();  history.push(config.route.NSApplicantDetails); }}>{config.btnName.Back}</button>
                                        }
                                        <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                                    </div>
                                </div> 
                            </FieldWrapper>
                     
                            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
                       
                        </fieldset>
                    </FormElement>
                    )}>
                    </Form>
                    </FormContainer>
                    {isSaving && <Loading />} 
        </div>
    )
}

export default ShareholdersDetails